@if (filteredDailyReportsList.length) {
  <div class="wrapper flex flex-col gap-[40px]">
    @for (report of filteredDailyReportsList; track report) {
      <div class="each-report">
        <div (click)="selectReportId(report.id)" [class]="'header flex justify-between' + ' ' + report.status">
          <div class="left">
            <div class="name text-type-5">
              {{ report?.createdBy?.first_name + ' ' + report?.createdBy?.last_name }}
            </div>
            <div class="filed-on text-type-10">
              {{ report?.created_at | date : 'hh:mm a on MMMM dd, yyyy' }}
            </div>
            <div class="status text-type-10">
              {{
              report.status === 'submitted' || report.status === 'reviewed' ? 'Awaiting Approval' : report.statusText
              }}
            </div>
          </div>
          <div class="right flex flex-row gap-[10px]">
            <mat-icon [svgIcon]="selectedReportId === report.id ? 'chevron-up' : 'chevron-down'" class="chevron" />
            <mat-icon (click)="$event.stopPropagation()" [matMenuTriggerFor]="menu" class="chevron !mt-[5px]">
              more_horiz
            </mat-icon>
            <mat-menu #menu="matMenu">
              <button (click)="delete(report)" mat-menu-item>
                <mat-icon svgIcon="trash" />
                Delete report
              </button>
              <button (click)="copyTo(report)" mat-menu-item>
                <mat-icon svgIcon="plus" />
                Copy to
              </button>
            </mat-menu>
          </div>
        </div>
        @if (selectedReportId === report.id) {
          <div class="content">
            <hr class="divider" />
            <app-daily-report-two />
            @for (na of (workflowService.canExecute() ? report?.['next-actions'] : []); track na) {
              @if (na?.actions?.length > 0) {
                <div>
                  <hr class="divider" />
                  <div class="work-flow-section min-h-[95px] flex flex-col justify-center items-center">
                    <div class="form-section w-full my-[20px]">
                      <app-text-area
                        [controlName]="formInputInfo?.name"
                        [label]="formInputInfo?.label"
                        [parentFormGroup]="form"
                        />
                    </div>
                    @for (na of report?.['next-actions']; track na) {
                      <div
                        class="next-actions-section w-full flex flex-row-reverse gap-[20px]"
                        >
                        @for (action of na?.actions; track action) {
                          @if (action?.options?.styles?.color === 'primary') {
                            <app-primary-button
                              (handleClick)="executeState(action)"
                              [color]="action?.options?.styles?.color"
                              class="action-btn w-1/3 mb-[20px]"
                              >
                              {{ action?.options?.label }}
                            </app-primary-button>
                          }
                          @if (action?.options?.styles?.color === 'accent' || action?.options?.styles?.color === 'warning') {
                            <app-secondary-button
                              (handleClick)="executeState(action)"
                              class="action-btn w-1/3 mb-[20px]"
                              >
                              {{ action?.options?.label }}
                            </app-secondary-button>
                          }
                        }
                      </div>
                    }
                  </div>
                </div>
              }
            }
          </div>
        }
      </div>
    }
  </div>
} @else {
  <div class="no-data w-[711px]">No reports available for the selected date.</div>
}
